"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cryptos = [
    "AVAX",
    "BAT",
    "BCH",
    "BNB",
    "BTC",
    "COMP",
    "ETH",
    "DOGE",
    "DOT",
    "ETH",
    "LTC",
    "MATIC",
    "SUSHI",
    "UNI",
    "USDC",
    "WBTC",
    "USDT",
    "XLM",
    "XRP",
    "VERSE",
];
exports.default = cryptos;
//# sourceMappingURL=cryptos.js.map